<template>
  <div>
    <img @click="handle" :src="img.back" />
  </div>
</template>

<script>
import back from '@/assets/images/common/left-arrow.svg'

export default {
  name: '',
  data() {
    return {
      img: {
        back,
      },
    }
  },
  methods: {
    handle() {
      this.$emit('click')
    },
  },
}
</script>
